import { useState } from "react";
import { api } from "../lib/api";
import { Package, Search } from "lucide-react";
import { toast } from "sonner";

export default function Track() {
  const [orderId, setOrderId] = useState("");
  const [email, setEmail] = useState("");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);

  const lookup = async (e) => {
    e.preventDefault();
    setLoading(true);
    setOrder(null);
    try {
      const r = await api.post("/orders/track", { order_id: orderId.trim(), email: email.trim() });
      setOrder(r.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Lookup failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-6 py-16" data-testid="track-page">
      <div className="font-mono-ui text-[11px] tracking-[0.3em] text-[var(--crimson)]">TRACK YOUR ORDER</div>
      <h1 className="font-serif-display text-5xl text-[var(--navy)] mt-2">Where&apos;s my stuff?</h1>
      <p className="mt-3 text-[var(--ink-soft)]">Pop in your order number and email to check status.</p>

      <form onSubmit={lookup} className="card-rustic p-6 mt-8 space-y-4">
        <input className="input-field" placeholder="Order ID" value={orderId} onChange={(e)=>setOrderId(e.target.value)} data-testid="track-order-id-input"/>
        <input className="input-field" type="email" placeholder="Email used at checkout" value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="track-email-input"/>
        <button className="btn-primary w-full justify-center" disabled={loading} data-testid="track-lookup-button">
          <Search className="w-4 h-4"/> {loading ? "Looking…" : "Find My Order"}
        </button>
      </form>

      {order && (
        <div className="card-rustic p-6 mt-6" data-testid="track-result">
          <div className="flex items-center gap-3 mb-4">
            <Package className="w-5 h-5 text-[var(--crimson)]"/>
            <div className="font-mono-ui text-xs tracking-[0.25em] uppercase text-[var(--ink-soft)]">Order {order.id.slice(0,8)}…</div>
          </div>
          <div className="font-serif-display text-3xl text-[var(--navy)]">Status: <span className="text-[var(--crimson)]">{order.status.replace(/_/g," ")}</span></div>
          {order.tracking_number && (
            <div className="mt-4 p-4 bg-[var(--bone-2)] rounded-sm">
              <div className="font-mono-ui text-[10px] tracking-[0.25em] uppercase text-[var(--ink-soft)]">TRACKING {order.tracking_carrier ? `· ${order.tracking_carrier}` : ""}</div>
              <div className="font-mono-ui text-base mt-1 text-[var(--navy)]" data-testid="track-number">{order.tracking_number}</div>
            </div>
          )}
          <div className="mt-4 text-sm text-[var(--ink-soft)]">
            {order.items.map((i, idx) => <div key={`${order.id}-${idx}`}>{i.quantity}× {i.name}</div>)}
          </div>
          <div className="mt-3 font-serif-display text-2xl text-[var(--crimson)]">${order.total.toFixed(2)}</div>
        </div>
      )}
    </div>
  );
}
